import type { ReactNode } from 'react';
import {
    TriageFrustrationControl,
    TriagePriorityControl,
    type TriageControlProps
} from './TriageControls';

function LabeledControl({ label, children }: { label: string; children: ReactNode }) {
    return (
        <div className="flex items-center gap-2">
            <span className="text-xs text-gray-500">{label}</span>
            {children}
        </div>
    );
}

// Inline "Priority:" / "Frustration:" pair for the Messages View header.
export function TriageHeaderControls({ align = 'right', ...props }: TriageControlProps) {
    return (
        <>
            <LabeledControl label="Priority:">
                <TriagePriorityControl {...props} align={align} />
            </LabeledControl>
            <LabeledControl label="Frustration:">
                <TriageFrustrationControl {...props} align={align} />
            </LabeledControl>
        </>
    );
}
